import { useState, useEffect } from 'react';
import axios from 'axios';
import { buildUrl, ENDPOINTS } from '../config';

/**
 * 字段配置Hook
 * 统一管理字段配置的获取和缓存
 */
function useFieldConfig() {
    const [fields, setFields] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchFields();
    }, []);

    const fetchFields = async () => {
        try {
            setLoading(true);
            const response = await axios.get(buildUrl(ENDPOINTS.fields));
            setFields(response.data);
            setError(null);
        } catch (err) {
            console.error('获取字段配置失败:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // 刷新字段配置
    const refreshFields = () => {
        fetchFields();
    };

    // 获取已迁移的字段（用于表单和列表显示）
    const getMigratedFields = () => {
        return fields.filter(field => field.isMigrated);
    };

    // 获取列表显示字段（仅已迁移）
    const getListFields = () => {
        return fields.filter(field => field.showInList && field.isMigrated);
    };

    // 获取可编辑字段（仅已迁移）
    const getEditableFields = () => {
        return fields.filter(field => field.editable && field.isMigrated);
    };

    // 获取必填字段（仅已迁移）
    const getRequiredFields = () => {
        return fields.filter(field => field.required && field.isMigrated);
    };

    // 获取未迁移的字段
    const getUnmigratedFields = () => {
        return fields.filter(field => !field.isMigrated);
    };

    return {
        fields,
        loading,
        error,
        refreshFields,
        getMigratedFields,
        getListFields,
        getEditableFields,
        getRequiredFields,
        getUnmigratedFields
    };
}

export default useFieldConfig;
